import { z } from 'zod'

export const nameRegex = /^(?=.*[a-zA-Z])[^\n]*$/
export const isValidName = (value: string) => nameRegex.test(value)
export const isValidNameZodRule = z.custom<'name'>((v) => {
  return typeof v == 'string' ? isValidName(v) : false
}, 'validation.name')
